import React, { useCallback, useEffect, useState } from "react";
import {
    Button,
    ButtonGroup,
    IconButton,
    Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Model } from "../../utils/model";
import { Option } from "../../utils/option";
import { Loader } from "../Loader";
import {
    sumDiscountPrice,
    sumDiscountTotal,
    sumPrice,
    sumTotal,
    subTotal,
    getOptionData1,
} from "../../utils/quote";
import { useGlobalSnackBar } from "../../pages/SnackbarContext";
import { CustomDialog } from "../modal/CustomDialog";

type Props = {
    quoteModels?: any;
    companyInfo?: any;
    options: Option[];
    priceType?: string;
    setQuoteModels: any;
    isAdminPage: boolean;
};

export const PreviewContent: React.FC<Props> = ({
    quoteModels,
    companyInfo,
    options,
    priceType = "dealer_price",
    setQuoteModels,
    isAdminPage,
}) => {
    const [data, setData] = useState<any>([]);
    const [isLoding, setIsLoading] = useState<boolean>(true);
    const [openDeleteOption, setOpenDeleteOption] = useState<boolean>(false);
    const [activeQuoteModel, setActiveQuoteModel] = useState<any>({});
    const [activeQuoteOption, setActiveQuoteOption] = useState<any>({});

    const { showSnackBar } = useGlobalSnackBar();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const _modelOptionData = quoteModels?.map(
            (res: any) => {
                return {
                    model: {
                        ID: res?.ID,
                        model_name: res?.model_name,
                        part_number: res?.part_number,
                        dealer_price: res?.[priceType],
                        MSRP: res?.MSRP,
                        _id: res?._id,
                    },
                    options: getOptionData1(options, res?.chose_options),
                    qty: res.qty,
                };
            }
        );

        setData(_modelOptionData);
        setIsLoading(false);
    }, [quoteModels, options, companyInfo]);


    const checkZero = useCallback((val: number | undefined | null): string => {
        if (!val || val === 0) return "0";
        return `$${val.toFixed(2)}`;
    }, []);

    const handleSubtract = (option: Option, activeQuoteModel: Model) => {
        let number: number = (option?.QTYNumber || 1) - 1;
        if (number < 1) {
            number = 1;
            showSnackBar(`Minimum QTY 1.`, "error");
        }
        regenerate(option, activeQuoteModel, number);
    };

    const handleAdd = (option: Option, activeQuoteModel: Model) => {
        let number: number = (option?.QTYNumber || 1) + 1;
        if (number > (option?.QTY || 1)) {
            number = (option?.QTY || 1);
            showSnackBar(`Maximum QTY ${option?.QTY || 1}.`, "error");
        }
        regenerate(option, activeQuoteModel, number);
    };

    const regenerate = (option: Option, activeQuoteModel: Model, number: number) => {
        const _quoteModels = quoteModels.map((model: Model) => {
            // Only modify the active model
            if (model.ID === activeQuoteModel.ID) {
                // update QTY
                const updatedChosenOptions = model.chose_options.map(
                    (res: { ID: string }) => {
                        if (res.ID === option.ID) {
                            return { ...res, QTYNumber: number };
                        }
                        return res;
                    }
                );
                return { ...model, chose_options: updatedChosenOptions };
            }
            // Keep other models as is
            return model;
        });

        dispatch(setQuoteModels(_quoteModels));
    };

    const onDeleteOption = () => {
        const _quoteModels = quoteModels.map((model: Model) => {
            // Only modify the active model
            if (model.ID === activeQuoteModel.ID) {
                // Filter out the deleted option
                const updatedChosenOptions = model.chose_options.filter(
                    (option: { ID: string }) => option.ID !== activeQuoteOption.ID
                );
                return { ...model, chose_options: updatedChosenOptions };
            }
            // Keep other models as is
            return model;
        });
        dispatch(setQuoteModels(_quoteModels));
        setOpenDeleteOption(false);
    };

    if (isLoding) return <Loader isLoading={isLoding} />;

    return (
        <div
            style={{
                fontFamily: "Arial, Helvetica, sans-serif",
                fontSize: 14,
                // padding: ".4in .3in",
            }}
        >
            <div>

                <table
                    style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        textAlign: "left",
                        fontFamily: "Arial, Helvetica, sans-serif",
                        // fontSize: 8,
                    }}
                >
                    <thead>
                        <tr>
                            <th
                                style={{
                                    border: "1px solid #ddd",
                                    padding: 5,
                                    background: "black",
                                    color: "white",
                                }}
                            >
                                BF Part #
                            </th>
                            <th
                                style={{
                                    border: "1px solid #ddd",
                                    padding: 5,
                                    background: "black",
                                    color: "white",
                                }}
                            >
                                Product Name
                            </th>
                            <th
                                style={{
                                    border: "1px solid #ddd",
                                    padding: 5,
                                    background: "black",
                                    color: "white",
                                }}
                            >
                                Qty
                            </th>
                            <th
                                style={{
                                    border: "1px solid #ddd",
                                    padding: 5,
                                    background: "black",
                                    color: "white",
                                    width: "7%",
                                }}
                            >
                                {priceType === "MSRP" ? priceType : "Price"}
                            </th>
                            <th
                                style={{
                                    border: "1px solid #ddd",
                                    padding: 5,
                                    background: "black",
                                    color: "white",
                                }}
                            >
                                Total
                            </th>
                            <th
                                style={{
                                    border: "1px solid #ddd",
                                    padding: 5,
                                    background: "black",
                                    color: "white",
                                }}
                            />
                        </tr>
                    </thead>
                    <tbody>
                        {data?.map(({ model, options, qty }: any, index: number) => (
                            <>
                                <tr style={{ borderBottom: "1px solid" }}>
                                    <td>{model?.part_number}</td>
                                    <td>Model - {model?.model_name}</td>
                                    {/* <td>{qty}</td> */}
                                    <td style={{ textAlign: "center" }}>1</td>
                                    <td>{checkZero(model?.[priceType])}</td>
                                    {/* <td>${(model?.[priceType] * qty)?.toFixed(2)}</td> */}
                                    <td>{checkZero(model?.[priceType])}</td>
                                    <td>
                                        <Tooltip title="To add additional options, please edit the system">
                                            <IconButton color="primary">
                                                <ModeEditIcon
                                                    onClick={() =>
                                                        navigate(`/${!isAdminPage ? "_" : ""}models/${model.ID}*${model._id}/customize`)
                                                    }
                                                />
                                            </IconButton>
                                        </Tooltip>
                                    </td>
                                </tr>
                                {/* creates multiple identical line items logic */}
                                {options &&
                                    options.length > 0 &&
                                    options.map((res: any, no: number) =>
                                        // Array.from({ length: res?.QTYNumber }, (_, index) => (
                                        <tr key={`${res?.part_number}-${no}`} style={{ borderBottom: "1px solid" }}>
                                            <td style={{ paddingLeft: 20 }}>{res?.part_number}</td>
                                            <td style={{ paddingLeft: 20 }}>{no + 1}) Opt. {res?.option_name}</td>
                                            {/* <td>{qty}</td> */}
                                            {/* <td>{res?.QTYNumber}</td> */}
                                            <td>
                                                <ButtonGroup
                                                    variant="contained"
                                                    aria-label="outlined primary button group"
                                                    sx={{ mr: 1, ml: 1 }}
                                                >
                                                    <Button
                                                        onClick={() => handleSubtract(res, model)}
                                                        sx={{ color: "black", backgroundColor: "white", padding: 0, minWidth: "25px !important" }}
                                                        disabled={!res?.isQTYEnabled}
                                                    >
                                                        -
                                                    </Button>
                                                    <Button sx={{ color: "black", backgroundColor: "white", padding: 0, minWidth: "25px !important" }}>
                                                        {res?.QTYNumber}
                                                    </Button>
                                                    <Button
                                                        onClick={() => handleAdd(res, model)}
                                                        sx={{ color: "black", backgroundColor: "white", padding: 0, minWidth: "25px !important" }}
                                                        disabled={!res?.isQTYEnabled}
                                                    >
                                                        +
                                                    </Button>
                                                </ButtonGroup>
                                            </td>
                                            <td>{checkZero(res?.[priceType])}</td>
                                            {/* <td>${(res?.[priceType] * qty)?.toFixed(2)}</td> */}
                                            <td>{checkZero(res?.[priceType] * (res?.QTYNumber || 1))}</td>
                                            <td>
                                                <Tooltip title="Remove Option">
                                                    <IconButton
                                                        color="error"
                                                        onClick={() => {
                                                            setActiveQuoteModel(model);
                                                            setActiveQuoteOption(res);
                                                            setOpenDeleteOption(true);
                                                        }}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </td>
                                        </tr>
                                        // ))
                                    )}

                                {(process.env.REACT_APP_SERVER_TYPE === "spacex" || process.env.REACT_APP_SERVER_TYPE === "industrial") ? (
                                    <>
                                        {qty >= 10 && qty <= 24 && (
                                            <tr>
                                                <td>Volume Discount 10-24 Unit</td>
                                                <td>{`${companyInfo?.qty_discount_1}%`}</td>
                                                {/* <td>{qty}</td> */}
                                                <td>1</td>
                                                <td>
                                                    $-
                                                    {sumDiscountPrice(
                                                        model,
                                                        options,
                                                        companyInfo?.qty_discount_1,
                                                        priceType
                                                    ).toFixed(2)}
                                                </td>
                                                <td colSpan={2}>
                                                    $-
                                                    {sumDiscountTotal(
                                                        model,
                                                        options,
                                                        qty,
                                                        companyInfo?.qty_discount_1,
                                                        priceType
                                                    ).toFixed(2)}
                                                </td>
                                            </tr>
                                        )}
                                        {qty >= 25 && qty <= 49 && (
                                            <tr>
                                                <td>Volume Discount 25-49 Unit</td>
                                                <td>{`${companyInfo?.qty_discount_2}%`}</td>
                                                {/* <td>{qty}</td> */}
                                                <td>1</td>
                                                <td>
                                                    $-
                                                    {sumDiscountPrice(
                                                        model,
                                                        options,
                                                        companyInfo?.qty_discount_2,
                                                        priceType
                                                    ).toFixed(2)}
                                                </td>
                                                <td colSpan={2}>
                                                    $-
                                                    {sumDiscountTotal(
                                                        model,
                                                        options,
                                                        qty,
                                                        companyInfo?.qty_discount_2,
                                                        priceType
                                                    ).toFixed(2)}
                                                </td>
                                            </tr>
                                        )}
                                        {qty > 49 && (
                                            <tr>
                                                <td>Volume Discount 50+ Units</td>
                                                <td>{`${companyInfo?.qty_discount_3}%`}</td>
                                                {/* <td>{qty}</td> */}
                                                <td>1</td>
                                                <td>
                                                    $-
                                                    {sumDiscountPrice(
                                                        model,
                                                        options,
                                                        companyInfo?.qty_discount_3,
                                                        priceType
                                                    ).toFixed(2)}
                                                </td>
                                                <td colSpan={2}>
                                                    $-
                                                    {sumDiscountTotal(
                                                        model,
                                                        options,
                                                        qty,
                                                        companyInfo?.qty_discount_3,
                                                        priceType
                                                    ).toFixed(2)}
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {qty >= 5 && qty <= 9 && (
                                            <tr>
                                                <td>Volume Discount 5-9 Unit</td>
                                                <td>{`${companyInfo?.qty_discount_1}%`}</td>
                                                {/* <td>{qty}</td> */}
                                                <td>1</td>
                                                <td>
                                                    $-
                                                    {sumDiscountPrice(
                                                        model,
                                                        options,
                                                        companyInfo?.qty_discount_1,
                                                        priceType
                                                    ).toFixed(2)}
                                                </td>
                                                <td>
                                                    $-
                                                    {sumDiscountTotal(
                                                        model,
                                                        options,
                                                        qty,
                                                        companyInfo?.qty_discount_1,
                                                        priceType
                                                    ).toFixed(2)}
                                                </td>
                                            </tr>
                                        )}
                                        {qty > 9 && (
                                            <tr>
                                                <td>Volume Discount 10+ Units</td>
                                                <td>{`${companyInfo?.qty_discount_2}%`}</td>
                                                {/* <td>{qty}</td> */}
                                                <td>1</td>
                                                <td>
                                                    $-
                                                    {sumDiscountPrice(
                                                        model,
                                                        options,
                                                        companyInfo?.qty_discount_2,
                                                        priceType
                                                    ).toFixed(2)}
                                                </td>
                                                <td>
                                                    $-
                                                    {sumDiscountTotal(
                                                        model,
                                                        options,
                                                        qty,
                                                        companyInfo?.qty_discount_2,
                                                        priceType
                                                    ).toFixed(2)}
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                )}
                                <tr className="system">
                                    <td
                                        colSpan={2}
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: 3,
                                            background: "#282828",
                                            color: "white",
                                        }}
                                    >
                                        System {index + 1}
                                    </td>
                                    <td
                                        colSpan={2}
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: 3,
                                            background: "#282828",
                                            color: "white",
                                            textAlign: "right"
                                        }}
                                    >
                                        Price per system:
                                    </td>
                                    <td colSpan={2}
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: 3,
                                            background: "#282828",
                                            color: "white",
                                        }}
                                    >
                                        $
                                        {(process.env.REACT_APP_SERVER_TYPE === "spacex" || process.env.REACT_APP_SERVER_TYPE === "industrial") ? (
                                            <>
                                                {qty >= 10 && qty <= 24 &&
                                                    (
                                                        sumPrice(model, options, priceType) -
                                                        sumDiscountPrice(
                                                            model,
                                                            options,
                                                            companyInfo?.qty_discount_1,
                                                            priceType
                                                        )
                                                    )?.toFixed(2)
                                                }
                                                {qty >= 25 && qty <= 49 && (
                                                    (
                                                        sumPrice(model, options, priceType) -
                                                        sumDiscountPrice(
                                                            model,
                                                            options,
                                                            companyInfo?.qty_discount_2,
                                                            priceType
                                                        )
                                                    )?.toFixed(2)
                                                )}
                                                {qty > 49 && (
                                                    (
                                                        sumPrice(model, options, priceType) -
                                                        sumDiscountPrice(
                                                            model,
                                                            options,
                                                            companyInfo?.qty_discount_3,
                                                            priceType
                                                        )
                                                    )?.toFixed(2)
                                                )}
                                                {qty < 10 && sumPrice(model, options, priceType)?.toFixed(2)}
                                            </>
                                        ) : (
                                            <>
                                                {qty >= 5 &&
                                                    qty <= 9 &&
                                                    (
                                                        sumPrice(model, options, priceType) -
                                                        sumDiscountPrice(
                                                            model,
                                                            options,
                                                            companyInfo?.qty_discount_1,
                                                            priceType
                                                        )
                                                    )?.toFixed(2)}
                                                {qty > 9 &&
                                                    (
                                                        sumPrice(model, options, priceType) -
                                                        sumDiscountPrice(
                                                            model,
                                                            options,
                                                            companyInfo?.qty_discount_2,
                                                            priceType
                                                        )
                                                    )?.toFixed(2)}
                                                {qty < 5 && sumPrice(model, options, priceType)?.toFixed(2)}
                                            </>
                                        )}
                                    </td>
                                </tr>
                                <tr className="system">
                                    <td
                                        colSpan={2}
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: 3,
                                            background: "#282828",
                                            color: "white",
                                            textAlign: "right"
                                        }}
                                    >
                                        System Quantity: {qty}
                                    </td>
                                    <td
                                        colSpan={2}
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: 3,
                                            background: "#282828",
                                            color: "white",
                                            textAlign: "right"
                                        }}
                                    >
                                        System {index + 1} Total:
                                    </td>
                                    <td colSpan={2}
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: 3,
                                            background: "#282828",
                                            color: "white",
                                        }}
                                    >
                                        $
                                        {(process.env.REACT_APP_SERVER_TYPE === "spacex" || process.env.REACT_APP_SERVER_TYPE === "industrial") ? (
                                            <>
                                                {qty >= 10 && qty <= 24 &&
                                                    (
                                                        sumTotal(model, options, qty, priceType) -
                                                        sumDiscountTotal(
                                                            model,
                                                            options,
                                                            qty,
                                                            companyInfo?.qty_discount_1,
                                                            priceType
                                                        )
                                                    )?.toFixed(2)
                                                }
                                                {qty >= 25 && qty <= 49 && (
                                                    (
                                                        sumTotal(model, options, qty, priceType) -
                                                        sumDiscountTotal(
                                                            model,
                                                            options,
                                                            qty,
                                                            companyInfo?.qty_discount_2,
                                                            priceType
                                                        )
                                                    )?.toFixed(2)
                                                )}
                                                {qty > 49 && (
                                                    (
                                                        sumTotal(model, options, qty, priceType) -
                                                        sumDiscountTotal(
                                                            model,
                                                            options,
                                                            qty,
                                                            companyInfo?.qty_discount_3,
                                                            priceType
                                                        )
                                                    )?.toFixed(2)
                                                )}
                                                {qty < 10 && sumTotal(model, options, qty, priceType)?.toFixed(2)}
                                            </>
                                        ) : (
                                            <>
                                                {qty >= 5 &&
                                                    qty <= 9 &&
                                                    (
                                                        sumTotal(model, options, qty, priceType) -
                                                        sumDiscountTotal(
                                                            model,
                                                            options,
                                                            qty,
                                                            companyInfo?.qty_discount_1,
                                                            priceType
                                                        )
                                                    )?.toFixed(2)}
                                                {qty > 9 &&
                                                    (
                                                        sumTotal(model, options, qty, priceType) -
                                                        sumDiscountTotal(
                                                            model,
                                                            options,
                                                            qty,
                                                            companyInfo?.qty_discount_2,
                                                            priceType
                                                        )
                                                    )?.toFixed(2)}
                                                {qty < 5 &&
                                                    sumTotal(model, options, qty, priceType)?.toFixed(2)}
                                            </>
                                        )}
                                    </td>
                                </tr>
                            </>
                        ))}
                        <tr>
                            <td colSpan={3} rowSpan={3} />
                            <td
                                style={{
                                    border: "1px solid #ddd",
                                    padding: 5,
                                    background: "#282828",
                                    color: "white",
                                }}
                            >
                                Subtotal
                            </td>
                            <td colSpan={2}
                                style={{
                                    border: "1px solid #ddd",
                                    padding: 5,
                                    background: "#282828",
                                    color: "white",
                                }}
                            >
                                ${subTotal(data, companyInfo, priceType)?.toFixed(2)}
                            </td>
                        </tr>
                        <tr>
                            <td
                                style={{
                                    border: "1px solid #ddd",
                                    padding: 5,
                                    background: "#282828",
                                    color: "white",
                                }}
                            >
                                Tax
                            </td>
                            <td colSpan={2}
                                style={{
                                    border: "1px solid #ddd",
                                    padding: 5,
                                    background: "#282828",
                                    color: "white",
                                }}
                            >
                                0
                            </td>
                        </tr>
                        <tr>
                            <td
                                style={{
                                    border: "1px solid #ddd",
                                    padding: 5,
                                    background: "#000000",
                                    color: "white",
                                }}
                            >
                                Total
                            </td>
                            <td colSpan={2}
                                style={{
                                    border: "1px solid #ddd",
                                    padding: 5,
                                    background: "#000000",
                                    color: "white",
                                }}
                            >
                                ${subTotal(data, companyInfo, priceType)?.toFixed(2)}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <CustomDialog
                title="Are you sure you want to remove this option?"
                openModal={openDeleteOption}
                handleClose={() => setOpenDeleteOption(false)}
                handleAction={onDeleteOption}
                buttonTitle={"Yes"}
                children={undefined}
            />
        </div>
    );
};
